import assetPath from '/app/brewery-packages/xds/xing-logo/src/assets/xing-favicon.ico';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')